import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The one book that gets me offline",
  "description": "",
  "published": "2012-03-13T00:00:00.000Z",
  "redirect_from": ["/blog/the-one-book-that-gets-me-offline/swizec/3958"],
  "categories": "Dark Tower, Gunslinger, HackerNews, Read, Reading, Roland Deschain, Stephen King, The Dark Tower VII: The Dark Tower, Twitter, Uncategorized, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There is a stack of books on my desk waiting to be read. They're not bad books. Some are considered the height of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Classics",
        "title": "Classics"
      }}>{`classical literature`}</a>{`, some are downright useful.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/3a11daa46cf911e180c9123138016265_74.jpg",
        "alt": "Unread.",
        "title": "Unread."
      }}></img></p>
    <p>{`And yet, they linger, waiting for months upon months, some for years. I'll get to them ... eventually.`}</p>
    <p>{`I used to be a voracious reader, going through books as if they were cookies. I still remember being eight or nine years old, waking up at 5am to read a book for two hours before getting ready for school.`}</p>
    <p>{`Evenings looked pretty much the same, I'd go to bed at 9pm and just read. Anything. Everything. Nothing was safe from my reading appetite. `}<em parentName="p">{`Just one more page! Please, mum?`}</em>{` was my catchphrase.`}</p>
    <h2 {...{
      "id": "an-internet"
    }}>{`An internet`}</h2>
    <p>{`Then I got an internet.`}</p>
    <p>{`I was still reading books. Mostly when school forced it upon me. Then I would devour a piece of classical literature in two afternoons. Because, you know, everything is easier at the last minute. And I would `}<em parentName="p">{`enjoy`}</em>{` the book. Absolutely love it!`}</p>
    <p>{`After the deadline ... back to the internet.`}</p>
    <p>{`This has gotten progressively worse to the point I simply don't allow myself near a bookstore anymore. What's the point in buying books if you never find the time to read them?`}</p>
    <h2 {...{
      "id": "brain-snacking"
    }}>{`Brain snacking`}</h2>
    <p>{`Funny thing is, I'm still a voracious reader. I probably read, or at least scan, upwards of 50 blog posts every day. Count in all the `}<a parentName="p" {...{
        "href": "http://twitter.com",
        "title": "Twitter"
      }}>{`tweets`}</a>{`, facebook updates, forum posts, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Internet_Relay_Chat",
        "title": "Internet Relay Chat"
      }}>{`IRC`}</a>{` conversations and `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/",
        "title": "Hacker News"
      }}>{`HackerNews`}</a>{`comments and I probably read 50 pages of "books" a day.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/119923039_1333cbbd02_m1.jpg",
        "alt": "Dark Tower",
        "title": "Dark Tower"
      }}></img></p>
    <p>{`50 pages.`}</p>
    <p>{`Time ... wasted.`}</p>
    <p>{`Of all those blogs and comments and tweets and everything, most of it is just interesting. Something to keep my mind occupied. A little candy to keep me happy while I go on about my day.`}</p>
    <p>{`Most of it isn't even that well written!`}</p>
    <p>{`But hey, it's always right there. At the tip of my fingers. Something new always coming along to satisfy my voracious appetite for brain food. Like crisps in the cupboard or chocolate in the fridge, who's got the time to prepare a meal when they can just barf down a snack?`}</p>
    <h2 {...{
      "id": "the-dark-tower-the-dark-tower-book-7"
    }}><a parentName="h2" {...{
        "href": "http://www.amazon.com/Dark-Tower-Book/dp/1880418622%3FSubscriptionId%3D0G81C5DAZ03ZR9WH9X82%26tag%3Dageewitahat-20%26linkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D1880418622",
        "title": "The Dark Tower (The Dark Tower, Book 7)"
      }}>{`The Dark Tower`}</a></h2>
    <p><a parentName="p" {...{
        "href": "http://www.rottentomatoes.com/celebrity/stephen_king",
        "title": "Stephen King"
      }}>{`Stephen King`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/Marveldarktower3.jpg",
        "alt": "Roland on the cover of the comic The Dark Towe...",
        "title": "Roland on the cover of the comic The Dark Towe..."
      }}></img></p>
    <p>{`Reading his `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.amazon.com/Writing-Memoir-Craft-Stephen-King/dp/0684853523%3FSubscriptionId%3D0G81C5DAZ03ZR9WH9X82%26tag%3Dageewitahat-20%26linkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3D0684853523",
          "title": "On Writing:  A Memoir of the Craft"
        }}>{`On writing`}</a></em>{` changed my style forever. He advocates a plain spoken style, people today don't have time to read. They don't even `}<em parentName="p">{`want`}</em>{` to read. You have to shove it down their throats. Tell them a cool story in a simple style and before they know it, they've just read a good book.`}</p>
    <p>{`Uh-oh!`}</p>
    <p>{`Head trick as Rausch would say. :)`}</p>
    <p>{`And The Dark Tower is one hell of a story. It reads just like a blog post! None of that high english nonsense, just plain words, lots of swearing, sex and violence. But hiding a very deep and meaningful tale if you care to look for one.`}</p>
    <p>{`The real winner is how the story is laid out. There's a break every two or three pages. Plenty of chapters. Every chapter almost meaninglessly divided into subchapters.`}</p>
    <p>{`Some a third of a page long. Some start in the middle of events.`}</p>
    <p>{`Sounds annoying, but it's brilliant.`}</p>
    <p>{`What's the biggest obstacle to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Reading_%28process%29",
        "title": "Reading (process)"
      }}>{`reading a book`}</a>{`? The commitment, before you is a bunch of text and you have to commit to reading all of it. Nobody wants to stop reading mid-sentence because the kettle is boiling.`}</p>
    <p>{`Rushing to finish the page so you can keep your place ... just because someone tweeted you and you have to respond.`}</p>
    <p>{`The worst part of reading a book is not knowing when the next break is coming and only having an hour of time to read. You might happen upon a break, or you might not. If you do, awesome, if you don't, you're left with a subconscious sense of guilt that you started something and didn't finish.`}</p>
    <p>{`With Stephen King that problem doesn't exist. You're guaranteed to finish `}<em parentName="p">{`something`}</em>{` every time you pick the book up. Even if you're just taking a shit.`}</p>
    <p>{`And the best part is, whenever you put the book down, it calls to you. It beckons in your dreams and you `}<em parentName="p">{`want`}</em>{` to get your arse offline and continue reading. So you `}<em parentName="p">{`will`}</em>{` go offline and finish the damn book.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.hollywood.com/news/Stephen_King_Dark_Tower_Reborn_at_Warner_Bros/20284768"
        }}>{`Stephen King's 'The Dark Tower' Reborn at Warner Bros.`}</a>{` (hollywood.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.aintitcool.com/node/54228"
        }}>{`Is Warner Bros and HBO about to pick up Ron Howard's adaptation of The Dark Tower?`}</a>{` (aintitcool.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://inspirationlocation.com/2012/03/09/media-fast/"
        }}>{`Media Fast`}</a>{` (inspirationlocation.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.thepunch.com.au/articles/if-you-dont-read-books-you-shouldnt-be-writing-one/"
        }}>{`If you don't read books you shouldn't be writing one`}</a>{` (thepunch.com.au)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/210313/Ive-read-a-lot-of-books-Now-I-want-to-do-something-productive"
        }}>{`I've read a lot of books. Now I want to do something productive.`}</a>{` (ask.metafilter.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ff183402-80a3-4b6d-bc8c-c06bb5428539",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      